import type { UseQueryOptions } from "@tanstack/react-query";
import type { NodeProgress, RunIo, RunsService } from "@/generated";
import { DATA_KEYS, useRemoteData } from "@/utils/useRemoteData";

export function useNodeIo(
  params: Parameters<typeof RunsService.getRunIo>[0],
  progress: NodeProgress | undefined,
  options: Partial<UseQueryOptions<RunIo>>
) {
  // Retries reuse run/node IDs. Cache terminal IO only for this execution,
  // including when polling jumps straight from a failed attempt to success.
  const execution = JSON.stringify([
    params.path.group_id,
    params.path.run_id,
    params.path.node_id,
    params.path.it,
    progress?.started_at,
    progress?.finished_at,
    progress?.status,
  ]);
  const request = {
    ...params,
    query: { ...params.query, skip_memory_cache: true },
  };
  return useRemoteData(DATA_KEYS.RUN_IO, request, {
    ...options,
    queryKey: [DATA_KEYS.RUN_IO, request, execution],
    // Keep the pager mounted between windows, but never carry an old
    // attempt's error into the next attempt while its IO is loading.
    placeholderData: (previous, query) =>
      query?.queryKey[2] === execution ? previous : undefined,
  });
}
